import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { ReactComponent as NavGiftbox } from "../Images/nav_giftbox.svg";
import { ReactComponent as NavMenu } from "../Images/nav_menu.svg";
import { ReactComponent as NavSetting } from "../Images/nav_setting.svg";
import { useGoToAddr } from "../Utils/navigationUtils";
import { getCompanyProfile } from "../Utils/sessionUtils";

const NavBar = () => {
  const { companyCode } = getCompanyProfile();
  const showDepartmentBattleMenu = companyCode === "citibank";

  return (
    <NavBox>
      {/* 대시보드 */}
      <div className="contentbox" style={{ marginTop: "40px" }}>
        <NavMenu style={{ verticalAlign: "top" }} />
        <span className="menutitle">대시보드</span>
        <NavBtn message="홈" addr="home" />
        <NavBtn message="구성원 관리/랭킹" addr="member" />
      </div>
      {/* 앱 관리 */}
      <div className="contentbox">
        <NavSetting style={{ verticalAlign: "top" }} />
        <span className="menutitle">앱 관리</span>
        <NavBtn message="공지사항 관리" addr="notice" />
        <NavBtn message="이벤트 대회 관리" addr="event" />
        {showDepartmentBattleMenu && (
          <NavBtn message="부서별 대항전 관리" addr="departmentBattle" />
        )}
        <NavBtn message="우리끼리 대회 관리" addr="meetWe" />
        <NavBtn message="배너 관리" addr="banner" />
        <NavBtn message="문의 관리" addr="qna" />
        <NavBtn message="푸시알림 관리" addr="push" />
        <NavBtn message="기부발걸음 관리" addr="donation" />
        <NavBtn message="우리기업 챌린지 관리" addr="challenge" />
      </div>
      {/* 추가 서비스 */}
      <div className="contentbox">
        <NavGiftbox style={{ verticalAlign: "top" }} />
        <span className="menutitle">추가 서비스</span>
        <NavBtn message="기프티콘샵" addr="gifticon" />
        {/* <div className="navbutton">
          <p className="menuname" style={{ color: "#8E96A0" }}>
            기프티콘샵
          </p>
        </div> */}
      </div>
    </NavBox>
  );
};

const NavBtn = ({ message, addr }) => {
  const goToAddr = useGoToAddr();
  const location = useLocation();
  const path = location.pathname.split("/")[1];
  const [isNowPath, setIsNowPath] = useState(false);

  useEffect(() => {
    if (path === addr) {
      setIsNowPath(true);
    } else {
      setIsNowPath(false);
    }
  }, [location.pathname, addr]);

  const handleClick = () => {
    goToAddr(addr);
  };

  return (
    <div
      className={`navbutton ${isNowPath ? "active" : "hover"}`}
      onClick={handleClick}
    >
      <p className={`menuname ${isNowPath ? "active" : "hover"}`}>{message}</p>
    </div>
  );
};

const NavBox = styled.div`
  z-index: 1;
  width: 300px;
  height: calc(100vh - 80px);
  height: calc(100dvh - 80px);
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #ffffff;
  position: fixed;
  margin-top: 80px;
  padding-bottom: 24px;
  box-sizing: border-box;
  /* 스크롤바 숨기기*/
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE, Edge */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari */
  }
  .contentbox {
    width: 240px;
    max-height: 900px;
    margin-left: 30px;
    margin-top: 20px;
  }
  .menutitle {
    font-size: 16px;
    font-family: "notoSans-bold";
    color: #8e96a0;
    margin-left: 4px;
  }
  .navbutton {
    width: 240px;
    height: 50px;
    border-radius: 10px;
    margin-top: 10px;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  .menuname {
    font-family: "notoSans-medium";
    font-size: 16px;
    color: #222222;
    margin-left: 28px;
  }
  .active {
    background-color: #dbe8fd;
    color: #1167ed;
  }
  .hover {
    &:hover {
      background-color: #e4e4e4;
    }
  }
`;

export default NavBar;
